import QueryBuilder from "../QueryBuilder"

export default class ThreeColumnImageSimpleRepository {
    constructor(protected contentName: string) {}

    async fetch() {
        const results = await new QueryBuilder()
            .buildQuery(this.contentName, ["'column_items': threeColumnSection"])
            .process()

        return results.getResultInfo()
    }
}
